import * as React from 'react';
import { cn } from '@/lib/cn';

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        ref={ref}
        className={cn(
          'flex h-11 w-full min-w-0 rounded-[10px] border border-line-1 bg-bg-1 px-3 text-base text-text-1 transition-colors sm:h-9 sm:text-[13px]',
          'placeholder:text-text-3',
          'focus-visible:border-violet/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-violet/15',
          'disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
